import script from "./TheLayoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLayoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheLayoutHeader.vue?vue&type=style&index=0&id=c9135c70&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9135c70"]])

export default __exports__